import TechnicalSetup from './TechnicalSetup';

export default TechnicalSetup;
